import GrooveShim from './GrooveShim'
import './styles.scss'

export default (window => {
  // eslint-disable-next-line no-param-reassign
  window.groove.classes.Shim = GrooveShim
})(global)
